import xss from "xss";
import Price from "../type/price";
import MetalItem from "../type/metal-item";
import { BasketStorage } from "./BasketStorage";
import { sumLimitForDeuBaEMSell } from "../utils/enums/CONSTANTS";

export class EdelmetallBasket extends BasketStorage {
  constructor() {
    super();    
    this.sumNetto = Price.create(0);
    this.sumBeforeTax = Price.create(0);
    this.sumTaxes = Price.create(0);
    this.mwstGes = Price.create(0);
    this.hasChangedDues = false;
    this.hasFilialChoice = false;
    this.enthalteneProvision = Price.create(0);
  }

  addItem(metal) {
    if (this.locked) return;
    let item = this.items.find(item => item.id === metal.id);
    if (item) {
      item.addItem(metal);
    } else {
      item = metal.clone();
      this.items.push(item);
    }
    this.updateSum();
  }

  changeAmount(id, amount) {
    const item = this.items.find(item => item.id === id);
    if (item) {
      item.changeAmount(amount);
      this.updateSum();
    }
  }

  incrementItem(id) {
    const item = this.items.find(item => item.id === id);
    if (item) {
      item.incrementAmount();
      this.updateSum();
    }
  }

  decrementItem(id) {
    const item = this.items.find(item => item.id === id);
    if (item) {
      item.decrementAmount();
      this.updateSum();
    }
  }

  checkFilialeOption() {

    //set doShip again
    if (this.isAnkaufShop) {
      this.doShip = "no";
    } 

    this.calcShippingChoice();
    this.hasFilialChoice = (
      this.hasShippingChoice &&
      this.doShip === "auslager"
    ) || (
        this.hasFilialen() &&
        (
          !this.hasShippingChoice ||
          this.doShip === "no"
        )
      );
    
    //console.info("checkFilialeOption - hasShippingChoice:", this.hasShippingChoice);
    //console.info("checkFilialeOption - doShip:", this.doShip);
    //console.info("checkFilialeOption - hasFilialen:", this.hasFilialen());
    //console.info("checkFilialeOption - hasFilialChoice:", this.hasFilialChoice);
    
    if (!this.hasFilialChoice && this.hasShippingChoice && !this.isAnkaufShop) this.setDoShip("yes");
    if (!this.hasFilialChoice ||
      (
        this.selectedFiliale &&
        !this.getFilialen().find(f => f.value === this.selectedFiliale.value)
      )
    ) {
      this.selectedFiliale = null;
    }
  }

  // items: list of all items in shopping basket
  // item: item for setting the dues
  setzeGebuehren() {
    if (this.gebuehren.betragBeiJederPosition) {
      // apply dues to every item
      this.items.forEach(item => {
        item.dues = this.duesAmount * 1000;
        if (item.changedDue) {
          item.setPositionDues(item.changedDue.getPrice());
        } else {
          item.setPositionDues(item.dues / 1000);
        }
      });
    } else {
      // apply dues only to one item
      this.items.forEach(item => item.setPositionDues(0));
      if (this.items.length > 0) {
        const targetItem = this.getMaxPriceItem();
        if (targetItem) {
          // Check if any item has a manual change and transfer it to the new target
          const changedItem = this.items.find(item => item.changedDue);
          if (changedItem && changedItem !== targetItem) {
            targetItem.changedDue = changedItem.changedDue;
            changedItem.changedDue = undefined;
          }

          if (targetItem.changedDue) {
            targetItem.setPositionDues(targetItem.changedDue.getPrice());
          } else {
            targetItem.setPositionDues(this.duesAmount);
          }
        }
      }
    }
    this.items.forEach(item => {
      let positionMwst = (item.positionDues.getPrice() + item.netto.getPrice()) * item.mwst;
      item.setPositionMwst(item.mwst > 0 ? Math.round(positionMwst) / 100 : 0);
    });
  }

  getMaxPriceItem() {
    if (!Array.isArray(this.items) || this.items.length === 0) return null;

    // Backend logic:
    // 1) take max brutto among items with mwst > 0
    // 2) if none have mwst > 0, take max brutto among all items
    const itemsWithMwst = this.items.filter(item => Number(item.mwst) > 0);

    const list = itemsWithMwst.length > 0 ? itemsWithMwst : this.items;

    return list.reduce(
      (max, item) => (item.brutto.getPrice() > max.brutto.getPrice() ? item : max),
      list[0]
    );
  }

  isDuesEditable(item) {
    if (!item) return false;
    if (this.gebuehren.betragBeiJederPosition) return true;
    const maxItem = this.getMaxPriceItem();
    return maxItem && item.id === maxItem.id;
  }

  changeDues(item, due) {
    if (!this.isDuesEditable(item)) return;
    item.changedDue = due;
    this.hasDues = true;
    this.updateSum();
  }

  updateSum() {
    // update items
    this.items.forEach(item => {
      if (this.hasDues) {
        this.setzeGebuehren();
      } else {
        let positionMwst = item.netto.getPrice() * item.mwst;
        item.setPositionMwst(Math.round(positionMwst) / 100);
      }
      item.positionSum = item.netto.clone().add(item.positionDues).add(item.positionMwst);
    });
    this.sum = this.items.reduce((prev, item) => prev.add(item.positionSum), new Price(0));

    this.sumNetto = this.items.reduce((prev, item) => prev.add(item.netto), new Price(0));

    this.sumBeforeTax = this.sumNetto.clone();

    this.positionDuesSum = this.items.reduce((prev, item) => {
      if (this.hasDues) {
        prev.add(item.positionDues);
      }
      return prev;
    }, new Price(0));

    const sDues = this.items.reduce((prev, item) => prev.add(item.positionDues), Price.create(0));
    // evaluating dues
    if (this.hasDues && !sDues.isZero()) {
      this.dues = sDues;
      this.sumBeforeTax.add(this.positionDuesSum);
    }
    // evaluating & adding shipping costs
    let shMwst = this.items.reduce((prev, item) => prev < item.mwst ? item.mwst : prev, 0);
    this.checkSum = this.sum.clone();
    if (shMwst > 0) {
      // add shipping to least expensive item with MWST
      const sumItem = this.items.reduce((prev, item) =>
        (
          item.positionSum.getPrice() < prev.positionSum.getPrice() &&
          item.mwst === shMwst
        ) || (
            prev.mwst < item.mwst
          )
          ? item
          : prev,
        this.items[0]
      );
      const sumShipping = sumItem.netto.clone().add(sumItem.positionDues).addNumber(this.shippingCosts);
      sumShipping.multiply((shMwst + 100) / 100);
      // replace positionSum with newly calculated sumShipping
      this.checkSum.subtract(sumItem.positionSum).add(sumShipping);
    } else {
      this.checkSum.addNumber(this.shippingCosts);
    }
    if (this.isDirectOrder() && this.checkSum.getPrice() <= this.maxShipment) {
      // add MWST to price ... get highest MWST from items
      this.shipping = Price.create(this.shippingCosts);
      this.sumBeforeTax.add(this.shipping);
      this.sum = this.checkSum.clone();
    } else {
      this.shipping = Price.create(0);
    }
    this.sumTaxes.set(this.sum.clone().subtract(this.sumBeforeTax).get());
    this.calcShippingChoice();
    this.checkFilialeOption();
    this.setEnthalteneProvision();
  }

  setEnthalteneProvision() {
    this.enthalteneProvision = Price.create(0);
    this.items.forEach(item => {
      this.enthalteneProvision.add(this.getImItemEnthalteneProvision(item));
    });
  }

  isTooHighForSell() {

//    console.log("EdelmetallBasket isTooHighForSell - numericLimit:", this.numericLimit);
//    console.log("EdelmetallBasket isTooHighForSell - maxSum:", this.maxSum);
    
//    return this.isAnkaufShop &&
//      this.numericLimit !== null &&
//      !isNaN(this.numericLimit) &&
//      this.sum.getPrice() > this.numericLimit;

    return this.isAnkaufShop &&
      this.maxSum !== null &&
      !isNaN(this.maxSum  ) &&
      this.sum.getPrice() > this.maxSum;
    
  }

  isTooHighForDeuBaEMSell() {    
    return this.sum.getPrice() > sumLimitForDeuBaEMSell;
  }


  getEnthalteneProvision() {
    if (!this.enthalteneProvision || typeof this.enthalteneProvision.getPrice !== "function") {
      this.setEnthalteneProvision();
    }
    return this.enthalteneProvision;
  }

  setMasterData(data) {
    this.setGebuehren((data || {}).gebuehren || {});
    this.setBaseMasterData(data);
    //Beim Ankauf wird automatisch die erste Filiale (Hauptstelle) zurückgegeben
    if (this.hasFilialen() && this.isAnkaufShop) this.selectedFiliale = this.filialen[0];

    //console.info("setMasterData - isAnkaufShop:", this.isAnkaufShop);
    //console.info("setMasterData - hasFilialen:", this.hasFilialen())

    if (!this.hasFilialen() && !this.isAnkaufShop) {
      this.doShip = "yes";
    }

    //console.info("setMasterData - doShip:", this.doShip);
  }

  updateData({ listeEdelmetall }) {
    if (!Array.isArray(listeEdelmetall)) return;
    this.items = this.items.map(item => {
      const props = listeEdelmetall.find(i => i.kennziffer === item.kennziffer);
      if (!props) return item;
      let rchargeKz = !!String(props.rchargeKz).match(/^(true|J)$/i);
      let diffsteuerungKz = !!String(props.diffsteuerungKz).match(/^(true|J)$/i);
      let preissteuerungKz = !!String(props.preissteuerungKz).match(/^(true|J)$/i);
      const newItem = MetalItem.create({
        kennziffer: props.kennziffer,
        id: item.id,
        name: props.bezeichnung,
        text: item.text,
        image: item.image,
        imageList: item.imageList,
        price: props.preis,
        mwst: props.mwst_prozent,
        kind: item.kind,
        make: item.make,
        amount: item.amount,
        margin: undefined,
        positionMwst: 0,
        positionDues: 0,
        positionSum: 0,
        popularity: item.popularity,
        innenProvision: props.innen_provision,
        konditionenProzent: props.konditionen_prozent,
        rchargeKz,
        diffsteuerungKz,
        preissteuerungKz,
        produktInfo: props.produktInfo
      });
      return newItem;
    });
    this.updateSum();
  }
  
  checkDirectBestellung() {
    if (this.isDirectOrder()) {
      return "ja";
    } else {
      return "nein";
    }
  }

  resetWarenkorb() {
    this.resetBaseWarenkorb();
    this.sumNetto = Price.create(0);
    this.sumTaxes = Price.create(0);
    this.sumBeforeTax = Price.create(0);
    this.enthalteneProvision = Price.create(0);
  }

  toJSONForCart(sessionId, catalogTimestamp, kundenId) {
    // structure: see if6RequestEdelmetallBestellung.json
    let data = {};
    data.edelmetallWarenkorb = {
      sessionId: sessionId,
      netto: this.sumNetto.getPrice(),
      steuer: this.sumTaxes.getPrice(),
      brutto: this.sum.getPrice(),
      versandkosten: this.shipping.getPrice(),
      direktbestellung: this.checkDirectBestellung(),
      gebuehren: this.positionDuesSum.getPrice(),

      summe: this.sum.getPrice(),
      produktkatalogTimestamp: catalogTimestamp,
      // item: this.items
    };
    data.edelmetallWarenkorbPos = this.items.map(i => i.toJSONForCart());
    data.kundenId = kundenId;
    return data;
  }

  calcInnenProvision() {
    if (!Array.isArray(this.items)) return 0;
    let innenProvision = this.items.reduce((prev, item) => {
      return prev + (Number(item.innenProvision) || 0) * item.amount;
    }, 0);
    return innenProvision;
  }

  getWarenkorbPos() {
    if (this.orderDataForOrder && Array.isArray(this.orderDataForOrder.edelmetallWarenkorbPos)) {
      return this.orderDataForOrder.edelmetallWarenkorbPos;
    }
    if (!Array.isArray(this.items)) {
      return [];
    }
    return this.items.map(i => i.toJSONForOrder());
  }

  toJSONForOrder(sessionId, timestamp, angebotsNr) {
    let data = {
      edelmetallWarenkorb: {
        sessionId: xss(sessionId),
        brutto: this.sum.getPrice(),
        netto: this.sumNetto.getPrice(),
        steuer: this.sumTaxes.getPrice(),
        versandkosten: this.shipping.getPrice(),
        direktbestellung: this.checkDirectBestellung(),
        gebuehren: this.positionDuesSum.getPrice(),
        summe: this.sum.getPrice(),
        produktkatalogTimestamp: xss(timestamp)
      },
      order: {
        netto: this.sumNetto.getPrice(),
        steuer: this.sumTaxes.getPrice(),
        versandkosten: this.shipping.getPrice(),
        direktbestellung: this.checkDirectBestellung(),
        gebuehren: this.positionDuesSum.getPrice(),
        summe: this.sum.getPrice(),
        produktkatalogTimestamp: xss(timestamp),
        angebotsNr: angebotsNr || ""
      },
      edelmetallWarenkorbPos: this.items.map(i => i.toJSONForOrder()),
      edelmetallWarenkorbPosRequest: this.items.map(i => i.toJSONForOrderRequest())
    };
    return data;
  }

  rebuildForApproval(data) {
    // check if there are products in basket
    if (data.listEdelmetallWarenkorbPos.length === 0) {
      this.sum = Price.create(0);
      this.sumNetto = Price.create(0);
      this.sumBeforeTax = Price.create(0);
      this.sumTaxes = Price.create(0);
      this.items = [];
      this.dirty = false;
      this.locked = false;
      this.setError("ein technisches Problem ist aufgetreten");
      return false;
    }

    //check if lenght of sent items and basket are equal
    if (this.items.length !== data.listEdelmetallWarenkorbPos.length) {
      this.setError('ERROR: The confirmed basket did not match the sent basket.');
    }

    let i, dItem, wItem;
    // merging delta into sent basket
    for (i = 0; i < data.listEdelmetallWarenkorbPos.length; i++) {
      wItem = data.listEdelmetallWarenkorbPos[i];
      dItem = this.findInListByProp(data.listEdelmetallWarenkorbDelta, "bestellpositionId", wItem.position);
      if (dItem != null) {
        //set basket to dirty.
        this.dirty = true;
        this.items[wItem.position].recreate({
          amount: wItem.anzahl,
          price: wItem.preis,
          netto: wItem.netto,
          brutto: wItem.brutto,
          mwst: wItem.mwstProzent,
          dirty: true
        });
        this.updateSum();
      } else if (this.items[wItem.position]) {
        this.items[wItem.position].dirty = false;
      }
    }
  }

  restoreData(data) {
    this.restoreBaseData(data);
    this.setGebuehren(data.gebuehren);
    this.setEnthalteneProvision();
    if (data.orderData) this.orderData = data.orderData;
  }

  setDoShip(doShip) {
    const triggerUpdate = this.doShip !== doShip;
    switch (doShip) {
      case "yes":
      case "no":
      case "auslager":
        this.doShip = doShip;
        break;
      default:
        break;
    };
    if (this.doShip !== "no") this.selectedFiliale = null;
    if (triggerUpdate) this.updateSum();
  }

  setGebuehren(newGebuehren) {
    this.gebuehren = { ...newGebuehren };
   
    this.recalcLimits();

    this.shippingCosts = Number(this.gebuehren.emDvBetrag);
    this.editCondition = String(this.gebuehren.konditionKz).toUpperCase() === "J";
    if (Number(this.gebuehren.emProz) !== 0.0) {
      this.duesPercentage = Number(this.gebuehren.emProz);
    } else {
      this.duesPercentage = 0;
    }
    if (Number(this.gebuehren.emBetrag) !== 0.0) {
      this.duesAmount = Number(this.gebuehren.emBetrag);
      this.hasDues = true;
    } else {
      this.duesAmount = 0;
      this.hasDues = false;
    }
  }

  recalcLimits() {
    // ✅ STEP 1: resolve orderLimit via shared base logic
    const numericLimit = this.getOrderLimit();
    this.numericLimit = numericLimit;

    const backendMaxShipment = Number(this.gebuehren.emDvMaxBetrag);
    const backendMaxSum = Number(this.gebuehren.emFvMaxBetrag);

    // ✅ STEP 2: apply minimum logic
    this.maxShipment = numericLimit !== null && !isNaN(numericLimit)
      ? Math.min(backendMaxShipment, numericLimit)
      : backendMaxShipment;

    if (this.isAnkaufShop) {
      this.maxSum = numericLimit;
    } else {
      this.maxSum = numericLimit !== null && !isNaN(numericLimit)
        ? Math.min(backendMaxSum, numericLimit)
        : backendMaxSum;
    }

  }

  getImItemEnthalteneProvision(item) {
    let preisabhängigeKondition = 0;

    if (!item.preissteuerungKz || this.isAnkaufShop) {
      // der Preis, den wir vom Backend bekommen ist inklusive preisabhängige Kondition
      // deswegen rechnen wir erst den originalBetrag aus und anhand dessen den Betrag pro Item
      const prozent = Number(item.konditionenProzent) || 0;

      let konditionProItem, originalPrice;
      if (this.isAnkaufShop) {
        originalPrice = item.price / (1 - prozent / 100);
        konditionProItem = originalPrice - item.price;
      } else {
        originalPrice = item.price / (1 + prozent / 100);
        konditionProItem = item.price - originalPrice;
      }

      preisabhängigeKondition = konditionProItem * item.amount;
    }

    return Price.create(item.amount * item.innenProvision + preisabhängigeKondition);
  }
}
